/**
 * Bridge between `apiRequest` and the re-auth prompt (DRA-350).
 *
 * `apiRequest` lives outside React, so it cannot open a dialog itself.
 * ReauthProvider registers a handler here at mount; apiRequest calls
 * requestReauth() when the API answers `reauth_required`, waits for the user to
 * confirm their identity, then retries the original request once.
 *
 * With no handler registered this resolves false and the caller surfaces the
 * error rather than hanging - the right behaviour before the provider mounts,
 * and in tests.
 */

type ReauthHandler = () => Promise<boolean>;

let handler: ReauthHandler | null = null;

export function setReauthHandler(next: ReauthHandler | null): void {
  handler = next;
}

/** Resolves true once the user has re-authenticated and the retry should proceed. */
export async function requestReauth(): Promise<boolean> {
  if (!handler) return false;
  return handler();
}
